import { Datagrid, FieldProps, ImageField, List, Resource, TextField, useRecordContext } from "react-admin";
import { BackofficeListTitle } from "../misc/BackofficeListTitle";
import { TheoryQuestionRecord } from "../providers/theoryQuestionsProvider";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";

function TheoryQuestionList() {
  return (
    <List title={<BackofficeListTitle />} exporter={false} sort={{ field: "id", order: "ASC" }}>
      <Datagrid bulkActionButtons={false}>
        <TextField label="ID" source="id" />
        <TextField label="Typ" source="typ" />
        <_ImageField label="Bild" source="imageUrl" sortable={false} />
        <TextField label="Frage" source="questionText" />
        <TextField label="Hint-Rating" source="hintRating" />
      </Datagrid>
    </List>
  );
}

function _ImageField(props: FieldProps) {
  const record = useRecordContext<TheoryQuestionRecord>();
  const imageField = (
    <ImageField {...props} sx={{ "& img": { margin: "0 !important", maxHeight: 40, objectFit: "contain" } }} />
  );

  if (record?.media !== "video") {
    return imageField;
  }

  return (
    <div style={{ position: "relative", maxHeight: 40, display: "inline-flex" }}>
      {imageField}
      <PlayCircleOutlineOutlinedIcon
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          pointerEvents: "none",
          color: "common.white",
          fontSize: 24,
        }}
      />
    </div>
  );
}

export const theoryQuestionsResource = (
  <Resource
    key="theoryQuestions"
    name="theoryQuestions"
    list={TheoryQuestionList}
    options={{ label: "Theoriefragen" }}
  />
);
